module.exports = __webpack_public_path__ + "img/官网-证书-资源库建设平台.bedef5d0.png";